import React, { useState } from 'react';
import {Button, TextField, Paper, Box, Typography, IconButton} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface LoginProps {
    onLogin: (username: string, password: string) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };


    const handleLogin = async () => {
        try {
            // Call the authentication API with the username and password
            const response = await fetch('/api/v1/auth/authenticate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ "username":username, "password":password }),
            });

            if (response.ok) {

                const { token } = await response.json();

                localStorage.setItem('token', token);
                window.location.href = '/home';

                onLogin(username, password);
            } else {
                alert("Wrong Credentials")
                console.error('Authentication failed');
            }
        } catch (error) {
            console.error('Error occurred while authenticating', error);
        }
    };
    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
            <Paper elevation={3} style={{ padding: '2rem', backgroundColor: '#f5f5f5' }}>
                <Typography
                    variant="h4"
                    align="center"
                    style={{
                        color: '#003366',
                        marginBottom: '2rem',
                        fontFamily: 'Arial, sans-serif',
                        fontWeight: 'bold',
                    }}
                >
                    vpn_pin
                </Typography>

                <TextField
                    label="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    fullWidth
                    margin="normal"
                    InputProps={{
                        endAdornment: (
                            <IconButton onClick={togglePasswordVisibility} edge="end">
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        ),
                    }}
                />
                <Button variant="contained" onClick={handleLogin} style={{ marginTop: '1rem' }} fullWidth>
                    Login
                </Button>
            </Paper>
        </Box>
    );
};

export default Login;






